import PackagesTable from "../Pages/Packages/Packages_Table";
import AddEditPackages from "../Pages/Packages/AddEdit_Packages";
import Updatepackage from "../Pages/Packages/Update_Package";
import { Navigate } from "react-router";

const role=localStorage.getItem("role")
export const PackagesRoutes= [
  {
    path: 'Pakete',
    element: < PackagesTable />
  },
  {
    path: 'Pakete/Updatepackage/:id',
    element: < Updatepackage />
  },
  {
    path: 'Pakete/AddEditPakete/',
    element: role !== 'manager' ? <Navigate to="/Pakete" replace /> : <AddEditPackages />
  },
];
